'use strict';

import angular from 'angular';
// import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';

import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import _ from "lodash";
import { $ } from 'jquery';

// import ngMessages from 'angular-messages';

import { routeConfig, anchroScrollConfig, responseCodeInterceptor, stateConfigChanged } from './app.config';
import { COMPONENTS } from './components';
import { PAGES } from './pages';
import constants from './app.constants';

require('../components/directives/files-input/files-input');
require('../components/directives/enlarge-image/enlarge-image');
require('angular-bootstrap-lightbox/dist/angular-bootstrap-lightbox.js');
require('angular-base64-upload/dist/angular-base64-upload.js');
require('daterangepicker/daterangepicker.js');
require('angularjs-daterangepicker');
require('bootstrap/dist/js/bootstrap.min.js');

import './app.scss';

const angularComponents = [
  ngCookies,
  ngResource, 
  ngSanitize, 
  'syncplicity-login.directives',
  'syncplicity-login.directives.fileInput',
  'angularjs.daterangepicker',
  'bootstrapLightbox',
  'btford.socket-io',  
  'naif.base64',
  uiRouter, 
  uiBootstrap, 
  constants
];

COMPONENTS.forEach(c => angularComponents.push(c));
PAGES.forEach(c => angularComponents.push(c));

angular.module('syncplicityLoginApp', angularComponents)
.config(routeConfig)
.config(responseCodeInterceptor)
.run(stateConfigChanged)
.run(() => {
  setTimeout(console.log.bind(console, '%cStop!', 'color: red; font-size: 50px'), 0);
  setTimeout(console.log.bind(console, '%cThis is a browser feature intended for developers only.!', 'font-size: 25px'), 0);
});

angular.element(document)
  .ready(() => {
    angular.bootstrap(document, ['syncplicityLoginApp'], { strictDi: false});
  });


// WEBPACK FOOTER //
// ./client/app/app.js